module.exports = __webpack_public_path__ + "media/images/logos/WS_illustration-site-vitrine-2022-36-c0b4d6fae16b6bbee19fe89d77e4f31c.svg";